module.exports = __webpack_public_path__ + "img/sergey_semin_vqpd1fc_Z36R5.261c0617.jpg";